import { useQuery } from '@tanstack/react-query';
import type { ActivityListResponse, ActivitySummary } from '../types';
import { api } from './client';
import { qk } from './keys';

export interface ActivityListParams {
  beforeCreatedAt?: string;
  action?: string;
  entityType?: string;
  entityId?: string;
  userId?: string;
  limit?: number;
}

export function useActivity(params: ActivityListParams) {
  return useQuery({
    queryKey: qk.activity(params),
    queryFn: () => api.get<ActivityListResponse>('/admin/activity', params),
  });
}

export function useActivitySummary(sinceHours: number) {
  return useQuery({
    queryKey: qk.activitySummary(sinceHours),
    queryFn: () =>
      api.get<ActivitySummary>('/admin/activity/summary', { sinceHours }),
  });
}
